import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20overlapping%20geometric%20shapes%20in%20warm%20coral%20terracotta%20sage%20green%20and%20soft%20sand%20tones%2C%20fashion%20editorial%20backdrop%20with%20organic%20flowing%20forms%20and%20subtle%20textile%20textures%2C%20sophisticated%20modern%20art%20gallery%20aesthetic%2C%20diffused%20gradient%20lighting%20with%20depth%20and%20dimension%2C%20luxurious%20contemporary%20atmosphere&width=1920&height=1200&seq=hero-bg-v2-main-01&orientation=landscape"
          alt="Superbuy Spreadsheet fashion background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight tracking-wide mb-6">
            Best Superbuy Spreadsheet
            <br />
            <span className="text-primary-300">2026</span>
          </h1>
          <p className="text-lg md:text-xl text-white/80 font-light max-w-2xl mx-auto mb-10 leading-relaxed">
            Trusted fashion, sneakers and streetwear spreadsheets. Your ultimate resource for finding the best deals and verified sellers.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-7 py-3.5 bg-foreground-950 text-white rounded-full text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center -ml-1">
                <i className="ri-shopping-bag-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              Superbuy Spreadsheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-7 py-3.5 bg-primary-500 text-white rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center -ml-1">
                <i className="ri-shopping-cart-2-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              Buy It Now
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>

          <div className="mt-16">
            <p className="text-white/50 text-xs uppercase tracking-widest mb-4">Scroll to explore</p>
            <div className="w-6 h-10 border-2 border-white/30 rounded-full mx-auto flex items-start justify-center p-1.5">
              <div className="w-1 h-3 bg-white/60 rounded-full animate-bounce"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}